import React, {createContext, useCallback, useContext, useState} from 'react'

type AppData = {
  subMenuName: string | undefined
  setSubMenuTitleName: (title: string | undefined) => void
  updateNotifications: boolean
  updateExpirationDate: boolean
  setUpdateNotifications: React.Dispatch<React.SetStateAction<boolean>>
  setUpdateExpirationDate: React.Dispatch<React.SetStateAction<boolean>>
}

export const AppContext = createContext({} as AppData)

export function AppProvider({children}: React.PropsWithChildren<any>) {
  const [subMenuName, _setSubMenuName] = useState<string | undefined>()

  const [updateNotifications, setUpdateNotifications] = useState(false)
  const [updateExpirationDate, setUpdateExpirationDate] = useState(false)

  const setSubMenuTitleName = useCallback((title: string | undefined) => {
    _setSubMenuName(title)
  }, [])

  return (
    <AppContext.Provider value={{subMenuName, setSubMenuTitleName, setUpdateNotifications, updateNotifications, updateExpirationDate, setUpdateExpirationDate}}>
      {children}
    </AppContext.Provider>
  )
}

export function useApp() {
  return useContext(AppContext)
}
